<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <div class="w-100 mt-4" *ngFor="let blogSection of activeArrData, index as i">
      <div class="vs-section-content has-outline-menu sectionMaster" *ngIf="blogSection.section">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="blogSection.sectionStatus === 'Activo'"
                  matTooltip="Editar sección" (click)="editBlogSection(blogSection, i + 1)">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  [matTooltip]="blogSection.sectionStatus === 'Activo' ? 'Ocultar sección' : 'Mostrar sección'"
                  (click)="changeBlogSectionStatus(blogSection.sectionId)" >
            <mat-icon>{{ blogSection['sectionStatus'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar sección" (click)="deleteBlogSection(blogSection)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content">
          <h2 class="vs-text-purple">{{blogSection.section}}</h2>
        </div>
      </div>
      <div class="vs-section-content mt-3 slides-edit sm">
        <div class="vs-outline-editCard">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Añadir item" (click)="createBlogPost(blogSection)">
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
        <perfect-scrollbar class="slides-scrollbar"
                           [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false}">
          <div class="slides-content">
            <div class="vs-benefitCard has-outline-menu" *ngFor="let blog of blogSection.detail"
                 [class.disabled-content]="blog.status === 'Desactivado'">
              <div class="img-description">
                <img [src]="blog.img"
                     onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'"
                     [alt]="'detail'">
              </div>
              <p><strong>{{blog.title}}</strong></p>
              <p>{{blog.name}}</p>
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="blog.status ==='Activo'"
                        matTooltip="Editar item"
                        (click)="editBlogPost(blog, blogSection, i + 1)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="blog['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'"
                        (click)="changeBlogStatus(blog.id, blogSection.sectionId)">
                  <mat-icon>{{ blog['status'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        matTooltip="Eliminar item"
                        (click)="deleteBlog(blog, blogSection)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
<!--    <div class="row status">-->
<!--      <div class="my-3 col-lg-6 col-xl-4"-->
<!--           *ngFor="let blog of activeArrData.detail, index as i">-->
<!--        <mat-card fxLayout="column" class="has-outline-menu card"-->
<!--                  fxLayout.lt-sm="row" fxLayoutAlign.lt-sm="start center">-->
<!--          <div class="vs-crud-menu">-->
<!--            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Card" (click)="editBlog(blog)">-->
<!--              <mat-icon>edit</mat-icon>-->
<!--            </button>-->
<!--&lt;!&ndash;            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"&ndash;&gt;-->
<!--&lt;!&ndash;                    [matTooltip]="blog.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"&ndash;&gt;-->
<!--&lt;!&ndash;                    (click)="changeStatus(blog, blog.status)">&ndash;&gt;-->
<!--&lt;!&ndash;              <mat-icon>{{ blog.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;            </button>&ndash;&gt;-->
<!--            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(blog)">-->
<!--              <mat-icon>delete_forever</mat-icon>-->
<!--            </button>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="order">&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="fw-bold m-0">{{blog.orderId}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="text-center" fxFlex.lt-sm="1 1 64px">-->
<!--            <img [src]="blog.img" class="my-3 blog-img">-->
<!--          </div>-->
<!--          <div class="text-center">-->
<!--            <div class="titulo_icono mb-3 fw-bold">-->
<!--              <span>{{blog.title}}</span>-->
<!--            </div>-->
<!--            <div class="subtitulo_icono">-->
<!--              <span>-->
<!--                {{blog.content | maxLength}}-->
<!--              </span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="d-flex mt-4">-->
<!--            <div class="mx-3">-->
<!--              <img mat-card-avatar [src]="blog.imgUser" class="example-header-image">-->
<!--            </div>-->
<!--            <div>-->
<!--              <h4 class="m-0 fw-bold">{{blog.name}}</h4>-->
<!--              <mat-card-subtitle class="m-0">{{blog.date}}</mat-card-subtitle>-->
<!--            </div>-->
<!--          </div>-->
<!--        </mat-card>-->
<!--      </div>-->
<!--    </div>-->
  </mat-tab>
  <mat-tab label="Deshabiltados ({{ inactiveArrData.length }})">
    <div class="w-100 mt-4 disabled-content" *ngFor="let blogSection of inactiveArrData">
      <div class="vs-section-content has-outline-menu sectionMaster" *ngIf="blogSection.section">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="blogSection.sectionStatus === 'Activo'"
                  matTooltip="Editar sección">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  [matTooltip]="blogSection.sectionStatus === 'Activo' ? 'Ocultar sección' : 'Mostrar sección'"
          (click)="changeBlogSectionStatus(blogSection.sectionId)">
            <mat-icon>{{ blogSection['sectionStatus'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar sección" (click)="deleteBlogSection(blogSection)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content">
          <h2 class="vs-text-purple">{{blogSection.section}}</h2>
        </div>
      </div>
      <div class="vs-section-content mt-3 slides-edit sm">
        <div class="vs-outline-editCard">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Añadir item">
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
        <perfect-scrollbar class="slides-scrollbar"
                           [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false}">
          <div class="slides-content">
            <div class="vs-benefitCard has-outline-menu" *ngFor="let blog of blogSection.detail"
                 [class.disabled-vs-content]="blog['status'] === 'Desactivado'">
              <img class="img-brand" [src]="blog['imagenLogo']" alt="brand-logo"
                   *ngIf="blog['imagenLogo']"
                   onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
              <div class="img-description">
                <img [src]="blog['imagen'] || blog['logoModal']"
                     onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'"
                     [alt]="'detail'">
              </div>
              <p><strong>{{blog.title}}</strong></p>
              <p>{{blog.name}}</p>
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="blog['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'"
                        (click)="changeBlogStatus(blog.id, blogSection.sectionId)">
                  <mat-icon>visibility_off</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        matTooltip="Eliminar item"
                        (click)="deleteBlog(blog, blogSection)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
<!--    <div class="row disabled-content">-->
<!--      <div class="my-3 col-12 col-md-6 col-lg-4" *ngFor="let blog of inactiveArrData, index as i">-->

<!--        <mat-card fxLayout="column" class="has-outline-menu card"-->
<!--                  fxLayout.lt-sm="row" fxLayoutAlign.lt-sm="start center">-->
<!--          <div class="vs-crud-menu">-->
<!--            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"-->
<!--                    [matTooltip]="blog.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"-->
<!--                    (click)="changeStatus(blog, blog.status)">-->
<!--              <mat-icon>{{ blog.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>-->
<!--            </button>-->
<!--            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(blog)">-->
<!--              <mat-icon>delete_forever</mat-icon>-->
<!--            </button>-->
<!--          </div>-->
<!--          <div class="order">-->
<!--            <p class="fw-bold m-0">{{blog.orderId}}</p>-->
<!--          </div>-->
<!--          <div class="text-center" fxFlex.lt-sm="1 1 64px">-->
<!--            <img [src]="blog.img" class="my-3 blog-img">-->
<!--          </div>-->
<!--          <div class="text-center">-->
<!--            <div class="titulo_icono mb-3 fw-bold">-->
<!--              <span>{{blog.title}}</span>-->
<!--            </div>-->
<!--            <div class="subtitulo_icono">-->
<!--              <span>-->
<!--                {{blog.content | maxLength}}-->
<!--              </span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="d-flex mt-4">-->
<!--            <div class="mx-3">-->
<!--              <img mat-card-avatar [src]="blog.authorImg" class="example-header-image">-->
<!--            </div>-->
<!--            <div>-->
<!--              <h4 class="m-0 fw-bold">{{blog.author}}</h4>-->
<!--              <mat-card-subtitle class="m-0">{{blog.date}}</mat-card-subtitle>-->
<!--            </div>-->
<!--          </div>-->
<!--        </mat-card>-->
<!--      </div>-->
<!--    </div>-->
  </mat-tab>
</mat-tab-group>


